import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { tracesSearchSchema } from "../schemas/traces-search-schema";
import { useStructuredSearchStore } from "../stores";

import { requestsSearchSchema } from "@/routes/request-logs/search/requests-search-schema";
import { useSidebarTab } from "@/components/SidebarSearchLayout/sidebar-tab-context";
import {
  isWorkspaceAnalyticsPathname,
  isWorkspaceRequestLogsTablePathname,
  isWorkspaceTracesAnalyticsPathname,
  isWorkspaceTracesSearchPathname,
} from "@/utils/workspacePathMatchers";

export const resolveStructuredSearchSchemaForSurface = ({
  pathname,
  sidebarTab,
}: {
  pathname: string;
  sidebarTab: "Requests" | "Traces" | undefined;
}) => {
  if (isWorkspaceTracesSearchPathname(pathname) || isWorkspaceTracesAnalyticsPathname(pathname)) {
    return tracesSearchSchema;
  }

  const isRequestsAnalyticsSurface =
    isWorkspaceAnalyticsPathname(pathname) || isWorkspaceRequestLogsTablePathname(pathname);

  if (isRequestsAnalyticsSurface) {
    return requestsSearchSchema;
  }

  if (sidebarTab === "Traces") {
    return tracesSearchSchema;
  }

  return requestsSearchSchema;
};

export const useActiveStructuredSearchSchema = () => {
  const location = useLocation();
  const sidebarTab = useSidebarTab();
  const structuredSearchStore = useStructuredSearchStore();

  useEffect(() => {
    const schema = resolveStructuredSearchSchemaForSurface({
      pathname: location.pathname,
      sidebarTab: sidebarTab?.activeTab,
    });
    structuredSearchStore.replaceSchema(schema);
  }, [location.pathname, sidebarTab?.activeTab, structuredSearchStore]);
};
